import { useState, useEffect } from 'react';

interface UseScrollDetectionReturn {
  isScrolled: boolean;
  scrollY: number;
}

export const useScrollDetection = (threshold: number = 200): UseScrollDetectionReturn => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [scrollY, setScrollY] = useState(0);

  useEffect(() => {
    let timeoutId: NodeJS.Timeout;
    
    const handleScroll = () => {
      const currentScrollY = window.scrollY;
      setScrollY(currentScrollY);
      
      // Debounce para evitar loops infinitos
      clearTimeout(timeoutId);
      timeoutId = setTimeout(() => {
        const newIsScrolled = currentScrollY > threshold;
        setIsScrolled(newIsScrolled);
      }, 10);
    };

    // Initial check
    handleScroll();

    window.addEventListener('scroll', handleScroll, { passive: true });
    
    return () => {
      clearTimeout(timeoutId);
      window.removeEventListener('scroll', handleScroll);
    };
  }, [threshold]);

  return { isScrolled, scrollY };
};

export default useScrollDetection;
